// extracted by mini-css-extract-plugin
export default {"marginQ1Element1":"Herencia_marginQ1Element1__tTsWm","container":"Herencia_container__2olP4"};